import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { BOX_IMAGE, finalCtaPoints } from '../data/content';
export function FinalCta() {
  return <section className="w-full bg-slate-950 px-5 py-12 text-white sm:py-16" data-id="element-64" data-mp="19epb9ofrmyvy">
      <div className="mx-auto flex max-w-[700px] flex-col items-center text-center" data-id="element-65" data-mp="19cmaqagzlncz">
        <h2 className="text-[1.6rem] font-extrabold uppercase leading-[0.95] tracking-tight sm:text-[2rem]" data-id="element-66" data-mp="15c2h3gvmh1vl">
          One Last Question
        </h2>
        <p className="mt-4 max-w-[560px] text-[1rem] leading-relaxed text-white/90" data-id="element-67" data-mp="1eejyni0c16c9">
          Keep searching Google for worksheets, activities and assessment
          ideas at the last minute… or{' '}
          <strong className="font-extrabold text-white" data-id="element-68" data-mp="1o3lhdfy9i1tx">
            open ONE system with everything already waiting for you?
          </strong>
        </p>

        <img src={BOX_IMAGE} alt="The HEALTH READY™ Bundle" className="mt-6 w-full max-w-[280px]" width={1240} height={1240} data-id="element-69" data-mp="221a0ai8rqywc" />

        <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[0.8rem] font-bold text-white" data-id="element-70" data-mp="n7fh7tovjafo">
          {finalCtaPoints.map(point => <li key={point} className="flex items-center gap-1.5" data-id="element-71" data-mp="x2z8g2shtky3">
              <CheckIcon className="h-3.5 w-3.5 shrink-0 text-orange-500" strokeWidth={3} aria-hidden="true" data-id="element-72" data-mp="122liy4gxsn37" />
              {point}
            </li>)}
        </ul>

        <div className="mt-6 flex items-baseline justify-center gap-3" data-id="element-73" data-mp="1b28mavt882yw">
          <span className="text-[1.5rem] font-bold text-white/70 line-through decoration-orange-500 decoration-2" data-id="element-74" data-mp="1fu052k6554eh">
            $97 USD
          </span>
          <span className="text-[2.6rem] font-black leading-none tracking-tight text-orange-500 sm:text-[3rem]" data-id="element-75" data-mp="1kvfpqb4ep8wc">
            $27 <span className="text-[1.2rem] uppercase" data-id="element-76" data-mp="1tu16c0qbiduh">USD Today</span>
          </span>
        </div>

        <CtaButton label="Yes! I Want It Today" className="mt-6 w-full max-w-[460px]" data-id="element-77" data-mp="3quow0r7donna" />

        <p className="mt-4 text-[0.85rem] font-bold uppercase tracking-wide text-white/80" data-id="element-78" data-mp="3lw473nxktqe5">
          One payment. No subscription. Instant access.
        </p>
      </div>
    </section>;
}